import React from 'react'
import imgCookies from '../images/cookies.jpg'
import SEO from '../components/seo'
import { Link } from 'react-router-dom'

const Politique = () => {
    return (
        <div className="main">
            <SEO subtitle={'Politique de Confidentialité'}
                title={"Walid Khaladi - Photographe Professionnel à Alger"}
                description={"Walid Khaladi est un Photographe Professionnel de mode et de célébrités qui réalise des portraits de magazines, des photographies publicitaires basé à Alger."}
                author={"@walidkhaladi"}
                url={"https://www.walidkhaladi.ml"}
                keywords={[
                    `walidkhalladi`,
                    `Walid`,
                    `Khaladi`,
                    `Politique de Confidentialité`,
                    `photographe`,
                    `alger`,
                    `Acceuil`,
                    `Portrait`,
                    `Nature`,
                    `Gallerie`,
                    `Évènement`,
                    `Hirak de 2019`,
                    "portfolio",
                    "Photo",
                    "website",
                    "professionnel"]} />
            
            <div className='bg_items'>
                <img className='bg_cookies' src={imgCookies} alt='Background cookies'></img>
                <h1 className='titre_acceuil'>Politique de Confidentialité</h1>
            </div>
            <div className='item-text'>
            <h3 className='titre_h3'><strong>POLITIQUE DE CONFIDENTIALITÉ :</strong></h3>
                <p style={{ textAlign : 'left'}}><br /><br />Cette politique s'applique au site&nbsp;: <span id="span_id_nom_du_site"  >walidkhaladi.ml</span> </p>
<p style={{textAlign : 'left'}}>Date de dernière mise à jour&nbsp;: <span id="span_id_date_derniere_maj"  >17 mai 2020</span></p>
<p style={{textAlign : 'left'}}><br /><br />Le respect de votre vie privée est de la plus haute importance pour <span id="span_id_nom_organisme_entreprise"  >Walid Khaladi</span>, qui est responsable de ce site.</p>
<p style={{textAlign : 'left'}}>La présente politique de confidentialité a pour but de vous exposer:</p>
<ul>
<li>La manière dont sont collectés et traités vos renseignements personnels. Doivent être considérés comme renseignements personnels tous les renseignements susceptibles de vous identifier. Il s'agit notamment de votre prénom et nom, de votre âge, de votre adresse postale, de votre adresse courriel de votre localisation ou encore de votre adresse IP&nbsp;;</li>
<li>Quels sont vos droits concernant ces renseignements;</li>
<li>Qui est responsable du traitement des renseignements personnels collectés et traités&nbsp;;</li>
<li>À qui ces renseignements sont transmis&nbsp;;</li>
<li>Éventuellement, la politique du site en matière de fichiers témoins ("cookies").</li>
</ul>
<p>Cette politique de confidentialité complète les Conditions générales d'utilisation que vous pouvez consulter à l'adresse ci-après&nbsp;:</p>
<p style={{margin : '10px auto'}}><span id="span_id_url_cgu"  ><Link rel="canonical" to='/cookies'>https://walidkhaladi.ml/cookies</Link></span></p>
<p className='titre_h3'><br /><br />1. COLLECTE DE RENSEIGNEMENTS PERSONNELS</p>
<p>Nous collectons les renseignements personnels suivants&nbsp;: </p>
<ul>
<li>Nom</li>
</ul>

<ul>
<li>Prénom</li>
</ul>

<ul>
<li>Adresse électronique</li>
</ul>

<ul>
<li>Numéro de téléphone/de télécopieur</li>
</ul>


<p>Les renseignements personnels que nous collectons sont recueillis par l'entremise des modes de collecte décrits ci-bas, dans les sections "Formulaires et modes de collecte" et suivantes.</p>
<p className='titre_h3'><br /><br />2. FORMULAIRES ET MODES DE COLLECTE</p>
<p>Vos renseignements personnels sont collectés par l'entremise des méthodes suivantes&nbsp;: </p>
<ul>
<li>Formulaire d'inscription au site Web</li>
</ul>

<ul>
<li>Formulaire de commande</li>
</ul>

<p>Nous utilisons les renseignements ainsi collectés pour les finalités suivantes&nbsp;: </p>
<ul>
<li>Suivis de commande</li>
</ul>

<ul>
<li>Statistiques</li>
</ul>

<ul>
<li>Contact</li>
</ul>

<ul>
<li>Gestion du site Web</li>
</ul>


<p className='titre_h3'><br /><br />3. INTERACTIVITÉ</p>
<p>Vos renseignements personnels sont également collectés par le biais de l'interactivité pouvant s'établir entre vous et notre site Web. Ces renseignements sont collectés par les moyens suivants&nbsp;: </p>
<ul>
<li><span id="span_id_collecte_interactive_autre"  ><span class="variable_vide">Formulaire de Contact</span></span></li>
</ul>

<p>Nous utilisons les renseignements ainsi collectés pour les finalités suivantes&nbsp;: </p>
<ul>
<li>Statistiques</li>
</ul>

<ul>
<li>Contact</li>
</ul>

<ul>
<li>Gestion du site web</li>
</ul>

<p className='titre_h3'><br /><br />4. FICHIERS JOURNAUX ET TÉMOINS</p>
<p>Nous recueillons certaines informations par le biais de fichiers journaux ("log files") et de fichiers témoins ("cookies"). Ces fichiers nous permettent de traiter des statistiques et des informations sur le trafic, de faciliter la navigation et d'améliorer le service pour votre confort. </p>
<p><strong><br />a) Description des fichiers témoins utilisés par le site</strong></p>
<p>Il s'agit principalement des informations suivantes&nbsp;: </p>
<ul>
<li><span id="span_id_collecte_cookies_autres"  ><span class="variable_vide">Cookies</span></span></li>
</ul>
<p>Le recours à de tels fichiers nous permet d'atteindre les objectifs suivants&nbsp;: </p>
<ul>
<li>Amélioration du service et accueil personnalisé</li>
</ul>

<ul>
<li>Création de profils personnalisés de consommation</li>
</ul>

<ul>
<li>Suivis de commande</li>
</ul>

<ul>
<li>Études statistiques</li>
</ul>


<p>En navigant sur le site, des fichiers témoins de tiers peuvent être enregistrés. Il s'agit particulièrement des tiers suivants&nbsp;:</p>
<p style={{margin : '10px auto'}}><span id="span_id_tiers_cookies"  ><span class="variable_vide">Cookies</span></span></p>
<p>De plus, le site intègre des boutons de réseaux sociaux vous permettant de partager votre activité sur le site. Des fichiers témoins de ces réseaux sociaux sont par conséquent susceptibles d'être stockés sur votre ordinateur lorsque vous utilisez ces fonctionnalités.</p>
<p>Ces sites disposent de politiques de confidentialité propres et de conditions générales d'utilisation possiblement différentes de notre site. Nous vous invitons à consulter les politiques de confidentialité et les conditions générales d'utilisation de ces sites. </p>
<p><strong><br />b) Opposition à l'utilisation de fichiers témoins par le site</strong></p>
<p>Vous pouvez vous opposer à l'enregistrement de ces fichiers témoins en configurant votre logiciel de navigation.</p>
<p>Dans le cas où vous décidez de désactiver les fichiers témoins, vous pourrez ensuite poursuivre votre navigation sur le site. Toutefois, tout dysfonctionnement du site provoqué par cette manipulation ne peut être considéré comme étant de notre fait.</p>
<p className='titre_h3'><br /><br />5. PARTAGE DES RENSEIGNEMENTS PERSONNELS </p>
<p>Les renseignements personnels collectés par le site ne sont transmis à aucun tiers et ne sont traités que par nous.</p>
<p className='titre_h3'><br /><br />6. DURÉE DE CONSERVATION DES RENSEIGNEMENTS PERSONNELS</p>
<p>Le responsable du traitement des renseignements personnels conservera dans ses systèmes informatiques du site et dans des conditions raisonnables de sécurité l'ensemble des renseignements personnels collectés pour une durée de&nbsp;: <span id="span_id_duree_conservation_renseignements"  ><span class="variable_vide">12 mois au maximum</span></span>.</p>
<p className='titre_h3'><br /><br />7. HÉBERGEMENT DES RENSEIGNEMENTS PERSONNELS</p>
<p>Notre site est hébergé par&nbsp;: <span id="span_id_denomination_sociale_de_l_hebergeur"  >Netlify</span>, dont le siège est situé à l'adresse ci-après&nbsp;:</p>
<p style={{margin : '10px auto'}}><span id="span_id_siege_social_de_l_hebergeur"  >2325 3rd Street, Suite 215, San Francisco, California 94107 aux États-Unis.</span></p>
<p>L'hébergeur peut être contacté au numéro de téléphone suivant&nbsp;: <span id="span_id_telephone_de_l_hebergeur"  ><span class="variable_vide">+1 415-691-1573</span></span>.</p>
<p>Les renseignements que nous collectons et traitons sont exclusivement hébergés et traités au Canada. </p>
<p className='titre_h3'><br /><br />8. RESPONSABLE DU TRAITEMENT DES RENSEIGNEMENTS PERSONNELS</p>
<p><strong>a) Le responsable du traitement des renseignements personnels</strong></p>
<p>Le responsable du traitement des renseignements personnels est&nbsp;: <span id="span_id_prenom_nom_responsable"  >Walid Khaladi</span>. Il peut être contacté de la manière suivante&nbsp;:</p>
<p style={{margin : '10px auto'}}><span id="span_id_methode_contact_rtd"  ><span class="variable_vide">walid5420@gmail.com</span></span></p>
<p>Le responsable du traitement des renseignements personnels est chargé de déterminer les finalités et les moyens mis au service du traitement des renseignements personnels</p>
<p><br /><strong>b) Obligations du responsable du traitement des renseignements personnels</strong></p>
<p>Le responsable du traitement des renseignements personnels s'engage à protéger les renseignements personnels collectés, à ne pas les transmettre à des tiers sans que vous n'en ayez été informé(e) et à respecter les finalités pour lesquelles ces renseignements ont été collectés.</p>
<p>De plus, le responsable du traitement des renseignements personnels s'engage à vous aviser en cas de rectification ou de suppression des renseignements personnels, à moins que cela n'entraîne pour lui des formalités, coûts ou démarches disproportionnés.</p>
<p>Dans le cas où l'intégrité, la confidentialité ou la sécurité de vos renseignements personnels est compromise, le responsable du traitement s'engage à vous en informer par tout moyen.</p>
<p className='titre_h3'><br /><br />9. DROIT D'OPPOSITION ET DE RETRAIT</p>
<p>Vous avez le droit de vous opposer au traitement de vos renseignements personnels par le site ("droit d'opposition"). Vous avez également le droit de demander à ce que vos renseignements personnels ne figurent plus, par exemple, dans une liste de diffusion ("droit de retrait").</p>
<p>Afin de formuler une opposition au traitement de vos renseignements personnels ou demander le retrait de vos renseignements personnels, vous devez suivre la procédure suivante&nbsp;:</p>
<p style={{margin : '10px auto'}}><span id="span_id_procedure_limitation_traitement"  ><span class="variable_vide">walid5420@gmail.com</span></span></p>
<p className='titre_h3'><br /><br />10. DROIT D'ACCÈS, DE RECTIFICATION ET DE SUPPRESSION</p>
<p>Vous pouvez prendre connaissance, mettre à jour, modifier ou demander la suppression des renseignements vous concernant, en respectant la procédure ci-après énoncée&nbsp;:</p>
<p style={{margin : '10px auto'}}><span id="span_id_procedure_acces_renseignements"  ><span class="variable_vide">walid5420@gmail.com</span></span></p>
<p className='titre_h3'><br /><br />11. SÉCURITÉ</p>
<p>Les informations personnelles que nous collectons sont conservées dans un environnement sécurisé. Les personnes travaillant pour nous sont tenues de respecter la confidentialité de vos informations.</p>
<p>Pour assurer la sécurité de vos informations personnelles, nous avons recours aux mesures suivantes&nbsp;: </p>
<ul>
<li>Protocole SSL (Secure Sockets Layer)</li>
</ul>

<ul>
<li>Protocole SET (Secure Electronic Transaction)</li>
</ul>

<ul>
<li>Gestion des accès - personne autorisée</li>
</ul>

<ul>
<li>Gestion des accès - personne concernée</li>
</ul>

<ul>
<li>Logiciel de surveillance du réseau</li>
</ul>

<ul>
<li>Sauvegarde automatique</li>
</ul>

<ul>
<li>Développement d'un certificat numérique</li>
</ul>

<ul>
<li>Identifiant/mot de passe</li>
</ul>

<ul>
<li>Pare-feu (Firewalls)</li>
</ul>

<p>Nous nous engageons à maintenir un haut degré de confidentialité en intégrant les dernières innovations technologiques permettant d'assurer la confidentialité de vos transactions. Toutefois, comme aucun mécanisme n'offre une sécurité maximale, une part de risque est toujours présente lorsqu'on utilise Internet pour transmettre des informations personnelles.</p>
<p className='titre_h3'><br /><br />12. ENFANTS</p>
<p>Notre site Web contient des sections destinées aux enfants. La collecte de leurs renseignements personnels se fait avec le consentement des parents ou du représentant de l'enfant. Nous demandons le consentement de ces derniers par le biais&nbsp;:</p>
<ul>
<li>Formulaire d'inscription</li>
</ul>

<ul>
<li>Formulaire de commande</li>
</ul>

<p className='titre_h3'><br /><br />13. CONDITIONS DE MODIFICATION DE LA POLITIQUE DE CONFIDENTIALITÉ</p>
<p>La présente politique de confidentialité peut être consulté à tout moment à l'adresse ci-après indiquée&nbsp;:</p>
<p style={{margin : '10px auto'}}><span id="span_id_adresse_politique_confidentialite"  ><Link rel="canonical" to='/politique-confidentialite'>https://walidkhaladi.ml/politique-confidentialite</Link></span></p>
<p>Nous nous réservons le droit de la modifier afin de garantir sa conformité avec le droit en vigueur.</p>
<p>Par conséquent, vous êtes invité(e) à venir consulter régulièrement cette politique de confidentialité afin de vous tenir informé(e) des derniers changements qui lui seront apportés. </p>
<p>Toutefois, en cas de modification substantielle de cette politique, vous en serez informé(e) de la manière suivante&nbsp;:</p>
            </div>
        </div>
    )
}

export default Politique
